import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, Box, Grid, FormGroup, FormControlLabel, Checkbox, Button
} from '@mui/material';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';
import { donorAggrementData } from './data';
import { AgreementBox } from '../shared/AgreementBox/AgreementBox';
import { ProfileInfoHeader } from '../shared/ProfileInfoHeader';
import { authorizationForDisclosureAgreementAction } from '../../redux/agreementCheckbox/Reducer';

export const AuthorizationForDisclosure = () => {
  const classes = useStyles();
  const history = useHistory();
  const profile = useSelector((state) => state.profile.profilInfo);
  const [hasReadAgreement, setHasReadAgreement] = useState(false);
  const agreementCheckbox = useSelector((state) => state.agreementCheckboxes.authorizationForDisclosureAgreement);
  const [checked, setChecked] = useState(agreementCheckbox);
  const dispatch = useDispatch();

  useEffect(() => {
    if (agreementCheckbox.userAgree && agreementCheckbox.termsAgree) {
      setHasReadAgreement(true);
    }
  }, [agreementCheckbox]);

  const signDocumentHandler = () => {
    history.push('/assignment-agreement');
  };

  const onBackHandler = () => {
    history.goBack();
  };

  const AgreementCheckHandler = (event) => {
    setChecked({ ...checked, [event.target.name]: event.target.checked });
    dispatch(authorizationForDisclosureAgreementAction({ ...checked, [event.target.name]: event.target.checked }));
  };

  const onEndOfScrollFunc = () => {
    setHasReadAgreement(true);
  };

  return (
    <Container maxWidth="md">
      <ProfileInfoHeader />
      <Grid container rowSpacing={{ xs: 1, sm: 1, md: 1 }} pb={{ xs: 1, md: 1 }} justifyContent="center">
        <Grid item xs={11} sm={7} md={6}>
          <Box>
            <Box className={classes.agreementHeading}>Authorization for Disclosure of Personal Health Information</Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container rowSpacing={{ xs: 1, sm: 1, md: 1 }} pb={{ xs: 1, md: 1 }} justifyContent="center">
        <Grid item xs={12} sm={12} md={12}>
          <AgreementBox isIndex={false} data={donorAggrementData} onEndOfScrollFunc={onEndOfScrollFunc} />
        </Grid>
      </Grid>
      <Grid container rowSpacing={{ xs: 1, sm: 1, md: 1 }} pb={{ xs: 3, md: 2 }} justifyContent="start">
        <Grid item xs={12} sm={12} md={12}>
          {!hasReadAgreement && <Box className={classes.checkboxErrorText}>* Please read the terms of the document to enable the checkboxes</Box>}
          <FormGroup>
            <FormControlLabel
              control={<Checkbox
                icon={<CheckBoxOutlineBlankOutlinedIcon />}
                checked={checked.userAgree}
                onChange={AgreementCheckHandler}
                inputProps={{ 'aria-label': 'controlled' }}
                name="userAgree"
                disabled={!hasReadAgreement}
              />}
              label={<Box component="span" fontSize={14}>I am <Box component="span" fontWeight={500}>{profile.First} {profile.Last}</Box> or thier legal guardian</Box>}
            />
            <FormControlLabel
              control={<Checkbox
                icon={<CheckBoxOutlineBlankOutlinedIcon />}
                checked={checked.termsAgree}
                onChange={AgreementCheckHandler}
                inputProps={{ 'aria-label': 'controlled' }}
                name="termsAgree"
                disabled={!hasReadAgreement}
              />}
              label={<Box component="span" fontSize={14}>I agree to the terms of this document</Box>}
            />
          </FormGroup>
        </Grid>
      </Grid>
      <Grid container rowSpacing={{ xs: 3, sm: 3, md: 0 }} justifyContent="center">
        <Grid item xs={10} sm={5} md={4} >
          <Box px={2} className={classes.btnWrapper}>
            <Button variant="contained" color="primary" disabled={(!checked.termsAgree || !checked.userAgree)} onClick={signDocumentHandler}>
              Sign And Submit (2/3)
            </Button>
          </Box>
        </Grid>
        <Grid item xs={10} sm={5} md={4} >
          <Box px={2} className={classes.btnWrapper}>
            <Button variant="contained" color="secondary" onClick={onBackHandler}>
              Back
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container >
  );
};
